import { useForm } from 'react-hook-form';
import { useGetClaimView } from './useGetClaimView';
import { useEffect, useState } from 'preact/hooks';
import { navigateTo } from '../../../../utils/navigation';
import { ROUTES_PATH } from '../../../../resources/routes-name';
import { useApproveClaim } from './useApproveClaim';
import { useModal } from '../../../../components/modal/hooks/useModal';
import { mobileBrandQuery } from '../../../../services/react-query/optionMasterQuery';
export const useGetClaimViewList = () => {
  const { control, getValues, setValue, reset, handleSubmit } = useForm();
  const [state, setState] = useState();
  const [data, setData] = useState();
  const [timelineList, setTimelineList] = useState();
  const { open: openNoApprove, onToggle: onToggleNoApprove } = useModal();
  const { open: openCancel, onToggle: onToggleCancel } = useModal();
  const { open: openUpdateProduct, onToggle: onToggleUpdateProduct } = useModal();
  const { data: mobileBrandOptions } = mobileBrandQuery();
  const [claimData, setClaimData] = useState();
  const queryParams = new URLSearchParams(window.location.search);
  const claimCode = queryParams.get('code');
  const { dataSource, loading: isLoaingClaimView } = useGetClaimView({
    reset,
    getValues,
    setValue,
    claimCode: state?.claimCode,
  });

  const { mutate: onSubmitApptoveClaim, loading: isLoadingApproveClaim } = useApproveClaim();

  const updateTimeline = () => {
    if (data?.timelineList) {
      const timeline = data.timelineList.map((item) => ({
        text: item?.optionStatusNameTh,
        color: item?.optionStatusCode === data?.claim.claimStatus ? 'green' : 'black',
      }));
      setTimelineList(timeline);
    }
  };

  const goBack = () => {
    navigateTo({ pathname: ROUTES_PATH.ROUTE_CLIAM_LIST.PATH, state: getValues() });
  };

  const gotoEditClaim = () => {
    navigateTo({
      pathname: ROUTES_PATH.ROUTE_CLAIM_EDIT.PATH,
      search: `?code=${claimData?.claimCode}`,
    });
  };

  const handleSubmitApproveClaim = () => {
    onSubmitApptoveClaim({ claimIdList: [claimData?.claimId] });
  };

  useEffect(() => {
    claimCode && setState({ claimCode });
  }, [claimCode]);

  useEffect(() => {
    dataSource && setData(dataSource);
  }, [dataSource]);

  useEffect(() => {
    if (data?.claim) {
      setClaimData({
        ...data.claim,
      });
      if (claimData?.remainingDays > 300000) {
        setValue('remainingDays', 'ตลอดชีวิต');
      }
      updateTimeline(data);
    }
  }, [data, setValue, claimData]);

  return {
    control,
    getValues,
    setValue,
    timelineList,
    claimData,
    isLoaingClaimView,
    goBack,
    handleSubmitApproveClaim,
    isLoadingApproveClaim,
    openNoApprove,
    onToggleNoApprove,
    openCancel,
    onToggleCancel,
    openUpdateProduct,
    onToggleUpdateProduct,
    handleSubmit,
    mobileBrandOptions,
    reset,
    gotoEditClaim,
  };
};
